import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import anywhere from "../img/anywhere.jpg";
import family from "../img/family.jpg";
import { primaryBtn } from "../styles";

const Testimonial = () => {
  return (
    <Reason id="Rewards">
      <Section>
        <div className="image">
          <div className="border"></div>

          <img src={family} alt="family" />
        </div>

        <div className="info info2">
          <h2>Save More Time</h2>
          <p>
            Save youself time of visiting a branch and waiting for lines. All
            day to day banking needs done online so you can spend more time with
            your loved ones. We’re all about better banking—for everyone. That’s
            why we’ve made joint money matters as easy as a click and a tap.
          </p>
          <LearnMore>Start Today</LearnMore>
        </div>
      </Section>

      <Section>
        <div className="info info-2-hide">
          <h2>Be Ready for the Future</h2>
          <p>
            Almost everything you do is online, so why shouldn’t your savings
            account be too? Going digital means no everyday banking fees, a high
            interest rate, convenient banking, and customer service available 7
            days a week from 8 AM to midnight, Eastern Time.
          </p>
          <LearnMore>Join Now</LearnMore>
        </div>
        <div className="image image-1">
          <div className="border"></div>

          <img src={anywhere} alt="family" />
        </div>

        <div className="info info-2-show">
          <h2>Be Ready for the Future</h2>
          <p>
            Almost everything you do is online, so why shouldn’t your savings
            account be too? Going digital means no everyday banking fees, a high
            interest rate, convenient banking, and customer service available 7
            days a week from 8 AM to midnight, Eastern Time.
          </p>
          <LearnMore>Join Now</LearnMore>
        </div>
      </Section>
    </Reason>
  );
};

export default Testimonial;

const Reason = styled(motion.div)`
  padding: 2rem 0rem;
  min-height: 20vh;

  @media (max-width: 770px) {
    padding: 3rem 0rem;
    padding-bottom: 1rem;
  }
`;

const Section = styled(motion.div)`
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  position: relative;

  padding: 5rem 12rem;

  @media (max-width: 1300px) {
    padding: 5rem 5rem;
  }

  @media (max-width: 1270px) {
    padding: 5rem 3rem;
  }

  @media (max-width: 770px) {
    flex-wrap: wrap;
    padding: 1rem 3rem;
  }

  .image {
    width: 37rem;
    height: 100%;
    text-align: center;
    position: relative;
    text-align: left;

    @media (max-width: 770px) {
      width: 100%;
    }

    .border {
      position: absolute;
      width: 35rem;
      height: 100%;
      border-radius: 0.7rem;
      margin-left: -1rem;
      margin-top: 0.5rem;
      background: #16c79a;
      opacity: 0.5;
      z-index: -10;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);

      @media (max-width: 1150px) {
        width: 30rem;
      }

      @media (max-width: 900px) {
        width: 25rem;
      }

      @media (max-width: 770px) {
        display: none;
      }
    }

    img {
      width: 35rem;
      height: 100%;
      border-radius: 0.5rem;

      object-fit: cover;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);

      @media (max-width: 1150px) {
        width: 30rem;
      }

      @media (max-width: 900px) {
        width: 25rem;
      }

      @media (max-width: 770px) {
        width: 100%;
      }
    }
  }

  .image-1 {
    text-align: right;

    @media (max-width: 770px) {
      text-align: left;
    }
  }

  .info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    text-align: left;
    padding: 0rem 5rem;

    @media (max-width: 900px) {
      padding: 0rem 3rem;
    }

    @media (max-width: 770px) {
      padding: 2rem 0rem;
      align-items: center;
      justify-content: center;
      text-align: center;
    }

    h2,
    p {
      white-space: normal;
      font-family: "Roboto", sans-serif;
      line-height: 1.5rem;
      padding-bottom: 2rem;
    }

    button {
      color: white;
      background: #19456b;
    }
  }

  .info-2-show {
    display: none;
    padding: 0;

    @media (max-width: 770px) {
      display: flex;
      padding: 2rem 0rem;
    }
  }

  .info-2-hide {
    @media (max-width: 770px) {
      display: none;
    }
  }

  @media (min-width: 1600px) {
    width: 100rem;
  }
`;

const LearnMore = styled(primaryBtn)`
  padding: 0.6rem 1.5rem;
`;
